module.exports = __webpack_public_path__ + "img/128.fd262bbc.jpg";